import { MediaType } from '@/@types';
import configuration from '@/configuration';
import React from 'react';
import { UIComponent } from '../..';

const getURL = (url: string, size?: string | number, q = 80, format = 'webp') => {
  if (!url.startsWith('https://cdn.peoople.app') || !configuration.images.api) {
    return url;
  }
  const queryString = new URLSearchParams({
    url,
    format,
    q: q.toString(),
  });
  if (size) {
    queryString.set('w', size.toString());
  }
  return `${configuration.images.api}?${queryString.toString()}`;
};

const Image: UIComponent<
  {
    media?: MediaType[];
    /**
     * Sizes in the format of "300 " or "600 (min-width: 768px)"
     */
    sizes?: string[];
    quality?: number;
  },
  'img',
  {
    getURL: typeof getURL;
  }
> = ({ src, media, alt, sizes = [], quality = 80, ...props }) => {
  let source: string | undefined = src;
  if (media) {
    source = media.find((x) => {
      return x.type === 'image';
    })?.source;
  }
  if (!source) {
    return null;
  }
  if (sizes.length > 0) {
    return (
      <picture {...props}>
        {sizes.map((x: string | number) => {
          const match = x.toString().match(/(?:(\(.*?\)))?\s*(\d+(?:px)?)/);
          if (!match) {
            return null;
          }

          const [, mediaQuery, size] = match;
          return <source key={x} media={mediaQuery} srcSet={getURL(source!, size, quality, 'webp')} type="image/webp" />;
        })}
        <source srcSet={getURL(source!, undefined, quality, 'webp')} type="image/webp" />
        <source srcSet={getURL(source!, undefined, quality, 'jpg')} type="image/jpeg" />
        <img {...props} src={source} alt={alt} loading="lazy" />
      </picture>
    );
  }

  source ||= (src || '').startsWith('/') ? `${configuration.host}${src}` : src;

  return <img {...props} src={source} alt={alt} />;
};

Image.getURL = getURL;

export default Image;
